// extracted by mini-css-extract-plugin
module.exports = {"container":"ChildProtectionPolicy_container__1FecG","content":"ChildProtectionPolicy_content__3CwPg"};